

















import { Component, Prop, Vue } from 'vue-property-decorator'
import ValidateUtils from '@/common/utils/ValidateUtils'

@Component({
  name: 'SidebarItemLink'
})
export default class extends Vue {
  @Prop({ required: true }) private to!: string

  private isExternal = ValidateUtils.isExternal
}
